// Optional analytics integrations are disabled until the Club chooses and
// configures a provider and publishes an appropriate consent flow.
export default function Metrics() {
  return null;
}
